<template>
  <button v-if="! connectedAccount(name)" @click="connect" class="py-2 px-4 flex items-center rounded">
    <i class="fab mr-2" :class="'fa-' + name"></i>
    Connect with {{ displayName }}
  </button>
  <button v-else @click="disconnect" class="py-2 px-4 flex items-center rounded">
      <i class="fab mr-2" :class="'fa-' + name"></i>
    Disconnect from {{ displayName }}
  </button>
</template>

<style lang="sass" scoped>

</style>

<script>
import api from '@/http'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'Social',
  props: ['name'],

  created () {
    if (this.$route.params.network === this.name && this.hasOAuthParameters(this.$route.query)) {
      this.register(this.$route.query)
    }
  },
  computed: {
    ...mapState(['profile_v2']),

    displayName () {
      return _.startCase(this.name)
    }
  },

  methods: {
    ...mapActions(['fetchProfileV2', 'displayToastNotification']),

    connect () {
      localStorage.setItem('additional_scope', false)
      api.get(`social/${this.name}/authorize`)
        .then(({ data }) => {
          window.location = data.redirect_url
        })
    },
    facebookAdditionalScope () {
      localStorage.setItem('additional_scope', true)
      api.get(`social/${this.name}/authorize/`, { params: {
        additional_scope: true
      } })
        .then(({ data }) => {
          window.location = data.redirect_url
        })
    },
    disconnect () {
      if (this.name === 'twitter') {
        return
      }
      api.post(`social/${this.name}/disconnect`).then(({ data }) => {
        this.fetchProfileV2()
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Facebook Connection',
          info: `You are now disconnected from facebook`
        })
      })
    },
    register (params) {
      api.get(`social/${this.name}/callback`, {
        params
      })
        .then(({ data }) => {
          this.fetchProfileV2()
          if (this.name === 'facebook' && !JSON.parse(localStorage.getItem('additional_scope'))) {
            this.facebookAdditionalScope()
          }
        })
    },

    connectedAccount (name) {
      if (this.profile_v2.socialNetworks !== undefined) {
        return this.profile_v2.socialNetworks.filter(network => network.name === name).length > 0
      }
    },

    hasOAuthParameters (query) {
      for (let key in query) {
        if (key.indexOf('oauth') !== -1 || key.indexOf('code') !== -1) {
          return true
        }
      }

      return false
    }
  }
}
</script>
